module.exports = __webpack_public_path__ + "static/media/TempSTEMACES.36c31eba.logo";